import "intersection-observer"; // IE11, Safari < 12.2
import "performance-polyfill"; // Safari < 11
import "@fastly/performance-observer-polyfill"; // Safari < 11

import "./abort-controller"; // IE 11, Safari < 12.2

(function (safariCheck) {
  if (!safariCheck) {
    return;
  }

  // https://gist.github.com/samthor/64b114e4a4f539915a95b91ffd340acc
  /**
   * Safari 10.1 supports modules, but does not support the `nomodule` attribute - it will
   * load <script nomodule> anyway. This snippet solve this problem, but only for script
   * tags that load external code, e.g.: <script nomodule src="nomodule.js"></script>
   *
   * Again: this will **not** prevent inline script, e.g.:
   * <script nomodule>alert('no modules');</script>.
   *
   * This workaround is possible because Safari supports the non-standard 'beforeload' event.
   * This allows us to trap the module and nomodule load.
   *
   * Note also that `nomodule` is supported in later versions of Safari - it's just 10.1 that
   * omits this attribute.
   */
  (function noModulePoly(proto) {
    const d = document;
    let check;
    let support = false;

    function onbeforeload(e) {
      const { target } = e;

      if (target === check) {
        support = true;
      } else if (!target.hasAttribute('nomodule') || !support) {
        return;
      }

      e.preventDefault();
    }

    if (!('noModule' in proto) && 'onbeforeload' in proto) {
      check = d.createElement('script');
      d.addEventListener('beforeload', onbeforeload, true);
      check.type = 'module';
      check.src = '.';
      d.head.appendChild(check);
      check.remove();
    }
  }(HTMLScriptElement.prototype));
}(/iP(?:[ao]d|hone)|Macintosh(?:[^C]+)Safari/.test(navigator.userAgent)));



// WEBPACK FOOTER //
// ./core/safari.js